export type PriceRow = {
  label: string
  note: string
  price: string
}

export const pricing: PriceRow[] = [
  {
    label: 'Ouverture de porte claquée',
    note: 'Sans dégradation, serrure standard',
    price: 'à partir de 89 €',
  },
  {
    label: 'Ouverture de porte fermée à clé',
    note: 'Selon le type de cylindre',
    price: 'à partir de 149 €',
  },
  {
    label: 'Remplacement de cylindre',
    note: 'Pose comprise, cylindre standard',
    price: 'à partir de 120 €',
  },
  {
    label: 'Serrure multipoints',
    note: 'Fourniture et pose, sur devis précis',
    price: 'à partir de 390 €',
  },
  {
    label: 'Blindage de porte',
    note: 'Après visite technique gratuite',
    price: 'sur devis',
  },
]

export const pricingNotes = [
  'Prix TTC hors fournitures spécifiques. Le montant exact est annoncé au téléphone puis confirmé par un devis écrit signé avant intervention.',
  'Majoration de nuit (22h – 7h), dimanche et jours fériés : + 30 %.',
]
